import SiteLayout from '@/components/feature/SiteLayout';
import CtaBanner from '@/components/feature/CtaBanner';
import { AboutHero, AboutApproach, AboutPeople, AboutPhilosophy } from './components/AboutSections';

export default function AboutPage() {
  return (
    <SiteLayout>
      <title>About CLEARY | Thoughtful Residential Cleaning</title>
      <meta name="description" content="Learn about CLEARY: a residential cleaning service built on attention to detail, respect for your space and clear communication in every clean." />
      <AboutHero />
      <AboutApproach />
      <AboutPeople />
      <AboutPhilosophy />
      <CtaBanner title="Let Us Take Care of the Details." primary={{ label: 'Explore Services', href: '/services' }} secondary={{ label: 'Get in Touch', href: '/contact' }} />
    </SiteLayout>
  );
}